var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pop-confirm"},[_c('el-popconfirm',{attrs:{"title":_vm.title,"cancelButtonText":"否","cancelButtonType":"primary","confirmButtonText":"是","confirmButtonType":"Text","icon":"el-icon-info","iconColor":"red"},on:{"onConfirm":_vm.onConfirm}},[_vm._t("default",null,{"slot":"reference"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-012007c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ApplyBasic/component/PopConfirmRed.vue
// module id = null
// module chunks = 